import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { EntityTypes } from '@bullhorn/bullhorn-types';
import { AppBridgeMspService } from '../../services/appBridgeMsp.service';
import { HttpMspService } from '../../services/httpMsp.service';

@Component({
  selector: 'app-msp-company',
  templateUrl: './msp-company.component.html',
})
export class MspCompanyComponent implements OnInit {
  loading = true;
  connected = true;
  companyIds: string[] = [];
  companies: any[] = [];

  constructor(
    private appBridgeService: AppBridgeMspService,
    private httpService: HttpMspService,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    if (this.connected) {
      this.appBridgeService.onRegistered.subscribe(this.onRegistered.bind(this));
      this.appBridgeService.registerCustomAction();
    }
  }

  private async onRegistered(isRegistered: boolean): Promise<void> {
    if (isRegistered) {
      const entityId = this.route.snapshot.queryParamMap.get('EntityID');
      
      // Get the company record to access customText12
      const company = await this.httpService.getEntity(
        EntityTypes.ClientCorporation,
        entityId as any,
        'customText12'
      );

      if (company?.data?.customText12) {
        this.companyIds = company.data.customText12.split(',').map(id => id.trim());
        
        // Fetch all related companies
        const companiesPromises = this.companyIds.map(id => 
          this.httpService.getEntity(
            EntityTypes.ClientCorporation,
            parseInt(id),
            'id,name,address'
          )
        );

        const results = await Promise.all(companiesPromises);
        this.companies = results.map(result => result.data);
      }

      this.loading = false;
    } else {
      this.connected = false;
      this.loading = false;
    }
  }
} 